export interface Award {
  id: string
  project: string
  award: string
  year: string
  link?: string
}

export const awards: Award[] = [
  {
    id: 'nova-2026',
    project: 'Nova Studio',
    award: 'Design Excellence Award',
    year: '2026',
  },
  {
    id: 'pixelcraft-2025',
    project: 'PixelCraft',
    award: 'Featured Project',
    year: '2025',
  },
  {
    id: 'brighttech-2025',
    project: 'BrightTech',
    award: 'Innovation in Web Design',
    year: '2025',
  },
  {
    id: 'horizonui-2024',
    project: 'Horizon UI',
    award: 'Creative Excellence',
    year: '2024',
  },
  {
    id: 'alphadigital-2024',
    project: 'Alpha Digital',
    award: 'Best User Experience',
    year: '2024',
  },
  {
    id: 'visionx-2023',
    project: 'VisionX',
    award: 'Outstanding Digital Project',
    year: '2023',
  },
  {
    id: 'codesphere-2023',
    project: 'CodeSphere',
    award: 'Modern Design Recognition',
    year: '2023',
  },
]